<div class="overlay">
  <div class="approval-modal">
    <div class="icon-wrap">
      <i class="bi bi-check"></i>
    </div>
    <h2>Your company account is under review</h2>

    <p>
      The BeExpert admin team will review and approve your request shortly.
      You'll be notified on your company email
      <strong>{{ data.email }}</strong> once your account is approved.
    </p>

    <div class="status-pill">Pending Approval</div>

    <hr />

    <button class="got-it-btn" (click)="logout()">Logout</button>
  </div>
</div>
